import {getImage} from "../../utils/utils";
import accountSVG from "../../images/account.svg";
import React from "react";
import styled from "styled-components";

const UserCardNoInteraction = ({user}) => {
    return (
        <MemberCard>
            <img className="user-img" src={getImage(user.photo, accountSVG)} alt="membre"/>
            <p> {user.firstName === "Deleted" ? "Utilisateur supprimé" : user.firstName}  </p>
            <p> {user.lastName === "User" ? "" : user.lastName} </p>
        </MemberCard>
    )
}

const MemberCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 90px;

  img {
    height: 50%;
    width: 50%;
    border-radius: 50%;
    object-fit: cover;
  }

  p {
    width: 80%;
    text-align: center;
    font-size: 12px;
  }

  @media (min-width: 900px) {
    img {
      height: 3em;
      width: 3em;
    }

    p {
      text-align: center;
      width: 90px;
    }
  }
`
export default UserCardNoInteraction